import { LoadingSpinnerPositionEnum } from "../../Lib/Enums/LoadingSpinnerPositionEnum";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { ProductCalcModel } from "../../Models/BestMatch/ProductCalcModel";
import { Product } from "../../Models/Tickets/Product";

export class BestMatchHandler {
    private betterMatchHolderName: string;
    private packageNameHolderName: string;
    private betterPriceHolderName: string;
    private originalSinglePriceName: string;
    private calculatedPriceHolderName: string;
    private divisor: number;
    private getBestMatchActivated: boolean;
    private axLoading: AxLoading;

    private requestQueue: BestMatchProSelectRequestValues[];
    private requestTimerSecCounter: number;
    private timer: NodeJS.Timer;

    private requestTimerSecCounterInitialValue = 1;

    constructor(getBestMatchActivated: boolean, divisor: number, betterMatchHolderName: string, packageNameHolderName: string, betterPriceHolderName: string,
        originalSinglePriceName: string, calculatedPriceHolderName: string) {
        this.betterMatchHolderName = betterMatchHolderName;
        this.packageNameHolderName = packageNameHolderName;
        this.betterPriceHolderName = betterPriceHolderName;
        this.originalSinglePriceName = originalSinglePriceName;
        this.calculatedPriceHolderName = calculatedPriceHolderName;
        this.divisor = divisor;
        this.getBestMatchActivated = getBestMatchActivated;
        this.axLoading = new AxLoading();
        this.requestQueue = [];
        this.requestTimerSecCounter = this.requestTimerSecCounterInitialValue;
    }

    // GetBestMatchTicketsV4Date
    async GetBestMatchTicketsV4Date(ticketTypeNo: number, poolNo: number, dateFrom: moment.Moment, productList: Product[]): Promise<BestMatchTicketResult[]> {
        return new Promise<BestMatchTicketResult[]>(async (resolve, reject) => {

            if (!this.getBestMatchActivated) {
                return resolve([]);
            }

            let soapDateFrom = '';

            if (dateFrom != undefined) {
                soapDateFrom = dateFrom.format("YYYY-MM-DD");
            }

            if (productList.filter(x => x.Quantity > 0).length < 1) {
                return resolve([]);
            }

            this.axLoading.ShowLoadingIndicatorForMultible($(".prod_selection__personType_row").toArray(), false, LoadingSpinnerPositionEnum.Left);

            let requestValues: BestMatchProSelectRequestValues = {
                ticketTypeNo: ticketTypeNo,
                poolNo: poolNo,
                dateFrom: soapDateFrom,
                productList: productList
            }

            this.requestQueue.push(requestValues);

            if (this.requestQueue.length > 1) {
                this.resetRequestTimer();
                reject();
            }
            else {
                let apiCallResult = await this.startRequestTimer();
                this.showBetterMatchPrices(apiCallResult, requestValues.productList);
                this.axLoading.HideLoadingIndicatorForMultible($(".prod_selection__personType_row").toArray());
                resolve(apiCallResult);
            }

            this.axLoading.HideLoadingIndicatorForMultible($(".prod_selection__personType_row").toArray());
            return resolve([]);
        });
    }

    // resetRequestTimer
    private resetRequestTimer() {
        this.requestTimerSecCounter = this.requestTimerSecCounterInitialValue;
    }

    // startRequestTimer
    private startRequestTimer(): Promise<BestMatchTicketResult[]> {
        return new Promise<BestMatchTicketResult[]>((resolve) => {
            this.timer = setInterval(async () => {

                    this.requestTimerSecCounter = this.requestTimerSecCounter - 1;

                    if (this.requestTimerSecCounter === 0) {

                        let requestValues = this.requestQueue[this.requestQueue.length - 1];

                        this.requestTimerSecCounter = this.requestTimerSecCounterInitialValue;

                        if (this.timer) {
                            clearInterval("" + this.timer);
                        }

                        let apiCallResult = await this.CallApi(requestValues).then((bestMatchResultList) => {
                            this.requestQueue = [];
                            resolve(bestMatchResultList);
                        });
                    }
                },
                1000);
        });
    }

    // CallApi
    private async CallApi(requestValues: BestMatchProSelectRequestValues): Promise<BestMatchTicketResult[]> {
        return new Promise<BestMatchTicketResult[]>((resolve) => {

            let productCalcMap = [];

            for (let prod of requestValues.productList) {

                let productCalcModel = new ProductCalcModel(requestValues.dateFrom, requestValues.dateFrom, prod.Quantity,
                    requestValues.ticketTypeNo, prod.SubProductIdentifier, requestValues.poolNo);

                productCalcMap.push({ "Key": prod.Id, "Value": productCalcModel });
            }

            let data = {
                productCalcMap: productCalcMap
            }

            AxessViewer.loadPartialView('/BestMatchPackage/GetBestMatchForTicketProdSelection', data, (x: BestMatchTicketResponse) => {
                resolve(x.bestMatchResults);
            }, {});
        });
    }

    // showBetterMatchPrices
    showBetterMatchPrices(bestMatchResults: BestMatchTicketResult[], productList: Product[]) {
        $(this.betterMatchHolderName).css('display', 'none');
        $(this.betterPriceHolderName).css('display', 'none');
        $(this.originalSinglePriceName).css('display', 'initial');
        $(this.calculatedPriceHolderName).css('text-decoration', 'none');
        $(this.calculatedPriceHolderName).removeClass('ax-color-gray-600');

        for (let bestMatchResultObj of bestMatchResults) {

            let bestMatchTicketResult = bestMatchResultObj as BestMatchTicketResult;

            let betterMatchHolder = $(`${this.betterMatchHolderName}[data_pType_betterMatch='${bestMatchTicketResult.productSelectionId}']`);
            $(betterMatchHolder).css('display', 'flex');

            let packageNameHolder = $(`${this.packageNameHolderName}[data_pType_packName='${bestMatchTicketResult.productSelectionId}']`);
            $(packageNameHolder).html(bestMatchTicketResult.packageName);

            let betterPriceHolder = $(`${this.betterPriceHolderName}[data_pType_betterPrice='${bestMatchTicketResult.productSelectionId}'] > span`);
            $(betterPriceHolder).html(this.GetBestMatchPositionPriceString(bestMatchTicketResult, productList));

            $(`${this.betterPriceHolderName}[data_pType_betterPrice='${bestMatchTicketResult.productSelectionId}']`).css('display', 'inline-block');

            let originalSinglePriceHolder = $(`${this.originalSinglePriceName}[data-base-single-price-holder='${bestMatchTicketResult.productSelectionId}']`);
            $(originalSinglePriceHolder).css('display', 'none');

            let calculatedPriceHolder = $(`${this.calculatedPriceHolderName}[data-calculated-price-holder='${bestMatchTicketResult.productSelectionId}']`);
            $(calculatedPriceHolder).css('text-decoration', 'line-through');
            $(calculatedPriceHolder).addClass('ax-color-gray-600');
        }
    }

    // GetBestMatchPositionPriceString
    GetBestMatchPositionPriceString(bestMatchResult: BestMatchTicketResult, productList: Product[]): string {
        let product = productList.find(x => x.Id == bestMatchResult.productSelectionId);
        let priceSumInt = this.GetBestMatchProductPriceSum(product.Quantity, product.Price, bestMatchResult);
        return priceSumInt.toFixed(2);
    }

    // GetBestMatchProductPrice
    GetBestMatchProductPriceSum(quantity: number, originalPrice: number, bestMatchResult: BestMatchTicketResult): number {
        if (bestMatchResult == null || bestMatchResult == undefined) {
            return 0;
        }

        if (bestMatchResult.countUnmatched == 0) {
            return quantity * this.GetPrice(bestMatchResult.betterTariffInt, this.divisor);
        }

        let matchedQuantity = quantity - bestMatchResult.countUnmatched;

        let sumBetterMatchProducts = matchedQuantity * this.GetPrice(bestMatchResult.betterTariffInt, this.divisor);

        let sumUnmatchedProducts = bestMatchResult.countUnmatched * this.GetPrice(originalPrice, this.divisor)

        return sumBetterMatchProducts + sumUnmatchedProducts;
    }

    // FindBestMatch
    FindBestMatch(prodSelectionId: number, bestMatchResults: BestMatchTicketResult[]): BestMatchTicketResult {
        let bestMatchResult = bestMatchResults.find(x => x.productSelectionId === prodSelectionId);
        return bestMatchResult;
    }

    // GetPrice
    GetPrice(price: number, divisor: number): number {
        return price / divisor;
    }

    // stopRequestTimer
    stopRequestTimer() {
        clearInterval('' + this.timer);
    }
}

class BestMatchProSelectRequestValues {
    ticketTypeNo: number;
    poolNo: number;
    dateFrom: string;
    productList: Product[];
}

interface BestMatchTicketResponse {
    bestMatchResults: BestMatchTicketResult[]
}

interface BestMatchTicketResult {
    betterTariff: string;
    betterTariffInt: number;
    productSelectionId: number;
    packageName: string;
    quantityFix: boolean;
    countUnmatched: number;
}


